import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemWidgetComponent } from 'components/work-item-lane-list/work-item-lane/work-item-widget/work-item-widget.component';
import { ChatWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-widget/chat-widget.module';
import { ChatPinInviteWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-pin-invite-widget/chat-pin-invite-widget.module';
import { EmailWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/email-widget/email-widget.module';
import { EmailComposeModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/email-compose/email-compose.module';
import { TextChatWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/text-chat-widget/text-chat-widget.module';
import { DiscussionWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/discussion-widget/discussion-widget.module';
import { LensWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/lens-widget/lens-widget.module';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';
import { GenesysChatWidgetModule } from './genesys-chat-widget/genesys-chat-widget.module';
import { GenesysEmailWidgetModule } from './genesys-email-widget/genesys-email-widget.module';
import { Turndown } from 'shared/services/turndown-wrapper/turndown.service';

@NgModule({
  imports: [
    CommonModule,
    ChatWidgetModule,
    ChatPinInviteWidgetModule,
    EmailWidgetModule,
    EmailComposeModule,
    LensWidgetModule,
    TextChatWidgetModule,
    DiscussionWidgetModule,
    GenesysChatWidgetModule,
    GenesysEmailWidgetModule
  ],
  declarations: [
    WorkItemWidgetComponent
  ],
  providers: [
    ClosingConfirmationService,
    Turndown
  ],
  exports: [
    WorkItemWidgetComponent
  ]
})
export class WorkItemWidgetModule {}
